import { ResponseErrorHandling } from "../../../../helper";
import commonService from "../../../../services/Common/service";
import { CommonActionTypes } from "../../../action-types";

export const getVASPList = () => async (dispatch) => {
  dispatch({ type: CommonActionTypes.PENDING, payload: true });

  try {
    const res = await commonService.get("/lookups/vasp_list");
    const vaspList = res.data;
    
    if (vaspList) {
      localStorage.setItem("vaspList", JSON.stringify(vaspList.data));
    }

    dispatch({
      type: CommonActionTypes.GET_VASP_LIST,
      payload: vaspList.data,
    });

    return vaspList;
  } catch (err) {
    const message =
      err.response?.data?.message || err.message || err.toString();

    ResponseErrorHandling(err.response, dispatch);

    dispatch({
      type: CommonActionTypes.REJECTED,
      payload: { message, isError: true },
    });
    return [];
  } finally {
    dispatch({ type: CommonActionTypes.RESET, payload: true });
  }
};
